

export default function(to, from, savedPosition) {
      if (to.path !== from.path && savedPosition) {
        window.scrollTo(0, 0);
      }
    }
